export const inventoryWorkloadsTableKeys = {
  AUTOSCALING: 'inventory-workloads-autoscaling-list',
  SAVINGS: 'inventory-workloads-savings-list',
  COMPUTE: 'inventory-workloads-compute',
  GPU_UTILIZATION: 'inventory-workloads-gpu-utilization',
  NETWORK: 'inventory-workloads-network',
  RELIABILITY: 'inventory-workloads-reliability',
} as const;

export const inventoryWorkloadTableKeys = {
  COMPUTE: 'inventory-workload-compute',
  GPU_UTILIZATION: 'inventory-workload-gpu-utilization',
  NETWORK: 'inventory-workload-network',
  RELIABILITY: 'inventory-workload-reliability',
} as const;

export const tableCacheKeys = {
  INVENTORY_WORKLOADS: {
    SAVINGS: 'inventory-workloads-savings-table',
    COMPUTE: 'inventory-workloads-compute-table',
    GPU_UTILIZATION: 'inventory-workloads-gpu-utilization-table',
    NETWORK: 'inventory-workloads-network-table',
    RELIABILITY: 'inventory-workloads-reliability-table',
  },
  INVENTORY_WORKLOAD: {
    COMPUTE: 'inventory-workload-compute-table',
    GPU_UTILIZATION: 'inventory-workload-gpu-utilization-table',
    NETWORK: 'inventory-workload-network-table',
    RELIABILITY: 'inventory-workload-reliability-table',
  },
} as const;
